import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faMinusCircle, faShieldHalved, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { Router } from '@angular/router';

import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';

@Component({
  selector: 'app-negative-stock',
  templateUrl: './negative-stock.component.html',
  styleUrls: ['./negative-stock.component.scss'],
  standalone: false
})
export class NegativeStockComponent implements OnChanges {
  protected readonly faMinusCircle = faMinusCircle;
  protected readonly faShieldHalved = faShieldHalved;
  protected readonly faChevronRight = faChevronRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  negativeStockList: any[] = [];
  stockCount: number = 0;
  loader: boolean = false;
  errMsg: string = '';
  scroolLoader: boolean = false;
  page: number = 0;
  endOfResults: boolean = false;

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
    private readonly router: Router,
    private readonly ledgersService: LedgersService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.refreshData()
    }
  }

  refreshData() {
    this.loader = true
    this.endOfResults = false;
    this.negativeStockList = []
    this.page = 0;
    this.stockCount = 0;
    this.getData();
  }

  getData() {
    this.errMsg = '';
    let params: any = {
      datcreated_date: this.selectedDate,
      page: this.page,
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getNegativeStock(params).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.scroolLoader = false;
        if (res.data) {
          this.stockCount = this.cmnService.parseNumberOrZero(res.data?.count)
          this.mapResponse(res.data?.result || [])
          if (res.data?.result?.length == 0) {
            this.endOfResults = true
          }
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.scroolLoader = false;
        this.errMsg = err?.error?.error?.message || "Failed to fetch response"
      }
    })
  }

  mapResponse(data: any) {
    let tabledata: any[] = (data || []).map((item: any) => {
      return {
        ...item,
        sku: `${item.tyreMake || ''} ${item.tyreModel || ''} ${item.tyreSize || ''}`,
        qty: this.cmnService.parseNumberOrZero(item.quantity),
        isToday: this.isToday(item.lastSaleDate)
      };
    });
    this.negativeStockList = [...this.negativeStockList, ...tabledata]
  }

  viewAllNegativeStock(content: any) {
    this.modalService.open(content, { size: 'lg', centered: true, scrollable: true });
  }

  isToday(dateStr: any): boolean {
    if (!dateStr) return false;
    try {
      const dateVal = new Date(dateStr);
      if (Number.isNaN(dateVal.getTime())) return false;
      const orderDateStr = dateVal.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      const todayDateStr = new Date().toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      return orderDateStr === todayDateStr;
    } catch (error) {
      const _ = error;
      return false;
    }
  }

  onRowClick(item: any) {
    this.modalService.dismissAll();
    if (this.selectedDate) {
      this.dayBookService.setSavedDayBookDate({
        currentDate: this.selectedDate,
        selectedBranchId: this.selectedBranch
      });
    }
    this.ledgersService.selectedSkuFilter = {
      tyreMake: item.tyreMake || '',
      tyreModel: item.tyreModel || '',
      tyreSize: item.tyreSize || '',
      company: item.companyId || '',
    };
    this.router.navigate(['/sku-ledger']);
  }

  onScroll() {
    if (this.endOfResults || this.scroolLoader || this.loader) return;
    this.page++;
    this.getData();
  }

}
